var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navigation',{ref:"nav_ref",on:{"callbackComponent":_vm.callbackComponent}}),_vm._v(" "),_vm._l((_vm.banner),function(item,index){return _c('h1',{key:index,staticClass:"text-hide ny_banner",style:({background:'url('+item.url+') no-repeat center  50%/cover'})},[_vm._v("公司简介")])}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('Footer')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c2b732","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/service/index.vue
// module id = null
// module chunks = 